/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungDto } from '../../models/buchung-dto';
import { DeleteBuchungForTimeframeDto } from '../../models/delete-buchung-for-timeframe-dto';

export interface DeleteBuchungForTarifAttributInTimeframe$Json$Params {

/**
 * Tarif Attribut das gematched werden soll
 */
  tarifAttribut: string;
  
    /**
     * Daten für die Buchung
     */
    body?: DeleteBuchungForTimeframeDto
}

export function deleteBuchungForTarifAttributInTimeframe$Json(http: HttpClient, rootUrl: string, params: DeleteBuchungForTarifAttributInTimeframe$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungDto>>> {
  const rb = new RequestBuilder(rootUrl, deleteBuchungForTarifAttributInTimeframe$Json.PATH, 'post');
  if (params) {
    rb.path('tarifAttribut', params.tarifAttribut, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BuchungDto>>;
    })
  );
}

deleteBuchungForTarifAttributInTimeframe$Json.PATH = '/v1/mitarbeiter/tarifattribut/{tarifAttribut}/deleteBuchungen/timeframe';
